import type { FC } from 'react';

import Typography from 'components/Typography';

import infoIcon from 'assets/info.svg';

import { TooltipBody, TooltipIcon, TooltipStyled } from './Tooltip.styled.ts';
import type { TooltipProps } from './Tooltip.types.ts';

const Tooltip: FC<TooltipProps> = ({ type, title, body }) => {
  const getIcon = () => {
    if (type === 'info') {
      return infoIcon;
    }

    return infoIcon;
  };

  return (
    <TooltipStyled>
      {type && <TooltipIcon src={getIcon()} />}
      <TooltipBody>
        <Typography type="Body" size="small">
          {title}
        </Typography>
        <Typography type="Body" size="small" style="light">
          {body}
        </Typography>
      </TooltipBody>
    </TooltipStyled>
  );
};

export default Tooltip;
